import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { FooterColumn, TrackingData } from './models/footer-column.interfaces';

@Component({
  selector: 'idp-footer-column',
  standalone: true,
  templateUrl: './footer-column.component.html',
  styleUrls: ['./footer-column.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule]
})
export class FooterColumnComponent {
  @Input() content: FooterColumn = {} as FooterColumn;
  @Input() isBusiness = false;
  @Input() darkSiteTheme = '';
  @Output() exit = new EventEmitter<TrackingData>();
  footerLinks!: ElementRef;
  currentOpenPanel: string | null = null;
  @Output() analyticsEvent = new EventEmitter<HTMLElement>();
  setTrackingEvents(prop1: string, prop2: string, e: MouseEvent): void {
    this.exit.emit({
      propertyValue: `footer: ${prop1}:${prop2}`,
      elementTarget: e.target
    });
    this.analyticsEvent.emit(e.target as HTMLElement);
  }
}
